<style scoped>
.mgt-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 74vh;
  background: #fff;
}

/* ── Top chrome ── */
.mgt-topbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  flex-shrink: 0;
  box-shadow: 0 1px 0 #F0F0F5;
}

.mgt-topbar-title {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 700;
  color: #181C32;
}

.mgt-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: none;
  background: #F5F8FA;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease;
}

.mgt-icon-btn:hover {
  background: #E4E6EF;
}

.mgt-body {
  flex: 1;
  min-height: 0;
  display: flex;
}

/* ── Left rail: category list, always visible ── */
.mgt-rail {
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid #EEF0F5;
  overflow-y: auto;
  padding: 14px 10px;
  -webkit-overflow-scrolling: touch;
}

.mgt-rail-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 2px;
  transition: background 0.15s ease;
}

.mgt-rail-row:hover {
  background: #F5F8FA;
}

.mgt-rail-row.active {
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.1), rgba(99, 102, 241, 0.03));
}

.mgt-rail-ic {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.mgt-rail-name {
  flex: 1;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 500;
  color: #3F4254;
}

.mgt-rail-row.active .mgt-rail-name {
  font-weight: 700;
  color: #4338CA;
}

.mgt-rail-divider {
  height: 1px;
  background: #EEF0F5;
  margin: 12px 4px;
}

.mgt-rail-section-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #A1A5B7;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 4px 10px 8px;
}

.mgt-rail-bottom-ic {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #F5F8FA;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mgt-rail>>>.list_min_heigt_common {
  min-height: 40px !important;
}

/* ── Right panel: selected category's content ── */
.mgt-panel {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 20px 26px 26px;
  -webkit-overflow-scrolling: touch;
}

.mgt-panel-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #B5B5C3;
  font-size: 13px;
}
</style>

<template>
  <div class="mgt-root">
    <div class="mgt-topbar">
      <span class="mgt-topbar-title">Menu</span>
      <button class="mgt-icon-btn" @click="$emit('to_close_MenuDialog')">
        <v-icon size="18">mdi-close</v-icon>
      </button>
    </div>

    <div class="mgt-body">
      <div class="mgt-rail">
        <div v-for="(item, idx) in topSections" :key="'top-' + idx" class="mgt-rail-row"
          :class="{ active: activeSection === item }" @click="activeSection = item">
          <div class="mgt-rail-ic" :style="{ background: accent(idx) }">
            <img v-if="svgUrl(item)" :src="svgUrl(item)" width="15" height="15" />
            <v-icon v-else-if="isMdiIcon(item.icon)" color="#fff" size="15">{{ item.icon }}</v-icon>
            <img v-else-if="item.icon" :src="item.icon" width="15" height="15"
              style="filter:brightness(0) invert(1)" />
          </div>
          <span class="mgt-rail-name">{{ item.name }}</span>
        </div>

        <template v-if="bottomSections.length">
          <div class="mgt-rail-divider"></div>
          <div class="mgt-rail-section-label">More</div>
          <template v-for="(item, idx) in bottomSections">
            <div v-if="item.has_children && item.children && item.children.length" :key="'bd-' + idx"
              class="mgt-rail-row" :class="{ active: activeSection === item }" @click="activeSection = item">
              <span class="mgt-rail-bottom-ic">
                <img v-if="svgUrl(item, '#7E8299')" :src="svgUrl(item, '#7E8299')" width="16" height="16" />
                <v-icon v-else-if="isMdiIcon(item.icon)" size="16" color="#7E8299">{{ item.icon }}</v-icon>
                <img v-else-if="item.icon" :src="item.icon" width="16" height="16" />
              </span>
              <span class="mgt-rail-name">{{ item.name }}</span>
            </div>
            <SideBarMenu v-else :key="'bl-' + idx" v-bind="passProps" :ItemObj="item"
              type_menu="Item_List_Menu_LEFTSide" @to_close_MenuDialog="$emit('to_close_MenuDialog')" />
          </template>
        </template>
      </div>

      <div class="mgt-panel">
        <template v-if="activeSection">
          <MegaMenuTree :items="activeSection.children" :section-headers="true" :pass-props="passProps"
            @to_close_MenuDialog="$emit('to_close_MenuDialog')" />
        </template>
        <div v-else class="mgt-panel-empty">Select a category</div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBarMenu from "@/components/Menu/SideBarMenu.vue";
import MegaMenuTree from "./MegaMenuTree.vue";
import { buildMegaMenuSections, isMdiIcon, svgIconUrl } from "./megaMenuData";

const CARD_ACCENTS = [
  "linear-gradient(135deg, #6366F1, #4338CA)",
  "linear-gradient(135deg, #EC4899, #BE185D)",
  "linear-gradient(135deg, #F59E0B, #D97706)",
  "linear-gradient(135deg, #10B981, #047857)",
  "linear-gradient(135deg, #3B82F6, #1D4ED8)",
  "linear-gradient(135deg, #8B5CF6, #6D28D9)",
];

export default {
  name: "MegaMenuTablet",
  components: { SideBarMenu, MegaMenuTree },
  props: {
    is_board_page: { type: Boolean, default: false },
    is__adani_page: { type: Boolean, default: false },
    is__gmr_page: { type: Boolean, default: false },
    is__vardhman_page: { type: Boolean, default: false },
    is__parle_page: { type: Boolean, default: false },
    is__granules_page: { type: Boolean, default: false },
    is__emami_page: { type: Boolean, default: false },
    is__family_page: { type: Boolean, default: false },
    menuDialog: { type: Boolean, default: false },
  },
  data() {
    return {
      topSections: [],
      bottomSections: [],
      activeSection: null,
    };
  },
  computed: {
    passProps() {
      return {
        is_board_page: this.is_board_page,
        is__adani_page: this.is__adani_page,
        is__gmr_page: this.is__gmr_page,
        is__vardhman_page: this.is__vardhman_page,
        is__parle_page: this.is__parle_page,
        is__granules_page: this.is__granules_page,
        is__emami_page: this.is__emami_page,
      };
    },
  },
  watch: {
    "$route.path"() {
      this.$nextTick(this.menu_load);
    },
    is__family_page() {
      this.$nextTick(this.menu_load);
    },
  },
  mounted() {
    this.menu_load();
  },
  methods: {
    isMdiIcon,
    svgUrl(item, color = "#ffffff") {
      return svgIconUrl(item, color);
    },
    accent(idx) {
      return CARD_ACCENTS[idx % CARD_ACCENTS.length];
    },
    menu_load() {
      const { topSections, bottomSections } = buildMegaMenuSections(
        this.is_board_page,
        this.is__family_page,
        this.$route.path
      );
      this.topSections = topSections;
      this.bottomSections = bottomSections;
      // Keep the current selection if it's still present after reload
      // (e.g. a route-driven refresh); otherwise land on whichever category
      // the current page actually lives under (is___select, stamped by
      // markSelectedByPath), falling back to the first category.
      if (!this.activeSection || !topSections.includes(this.activeSection)) {
        this.activeSection = topSections.find((item) => item.is___select) || topSections[0] || null;
      }
    },
  },
};
</script>
